module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Light.850fe8531da7e9779f8f31c7e381acb0.woff";